import {
  ChangeDetectionStrategy, ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject, Input,
  OnInit,
  Output
} from "@angular/core";
import {PANEL_DATA} from "../../../../commons/angular/services/panel.service";

interface PlanningDraftJobsSortingDialogModel {
  sortBy: string;
  sortByType: string;
}

require('./planning-draft-jobs-sorting-dialog.scss');
@Component({
  standalone: false,
  selector: 'app-planning-draft-jobs-sorting-dialog',
  templateUrl: './planning-draft-jobs-sorting-dialog.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningDraftJobsSortingDialogComponent implements OnInit {

  @Output() onSortTypeChange = new EventEmitter<{ sortBy: string, sortByType: string }>();

  public sortBy: string;
  public sortByType: string

  constructor(@Inject(PANEL_DATA) public data: PlanningDraftJobsSortingDialogModel) {
  }

  ngOnInit() {
    this.sortBy = this.data.sortBy;
    this.sortByType = this.data.sortByType;
  }

  onToggleSortTypeChange(sortBy: string, sortByType: string) {
    this.sortBy = sortBy;
    this.sortByType = sortByType;
    this.onSortTypeChange.emit({sortBy: sortBy, sortByType: sortByType});
  }

}
